import api from '@/global/api';
import { getTimeRange, DAY, SHARED_TIME_RANGES } from '@/processes/Settings';
import qs from 'query-string';
import _toLower from 'lodash/toLower';
import _get from 'lodash/get';
import _sortBy from 'lodash/sortBy';
import { getFloatOrDecimalNumber } from '@/shared/utils/formatters';
import { getApiMiningType } from '@/shared/utils/apiMiningType';

export const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getShares: build.query({
      query: (params = {}) => {
        const {
          dateRange = DAY,
          account,
          miner,
          coin,
          worker = '',
          offset = 0
        } = params;
        const { window, limit } = getTimeRange('', dateRange);
        const queryParams = qs.stringify({
          coin,
          worker,
          window,
          limit,
          offset,
        }, { skipNull: true })

        const { urlPart } = getApiMiningType({ miner, account, coin });

        return {
          url: `/v1/${urlPart}/shares?${queryParams}`,
          method: 'GET',
        }
      },
      transformResponse: (response: any) => {
        const items = _get(response, 'items', []);
        return _sortBy(items, 'timestamp').map(item => (
          {
            ...item,
            ...{
              invalidCount: getFloatOrDecimalNumber(item.invalidCount),
              validCount: getFloatOrDecimalNumber(item.validCount),
              staleCount: getFloatOrDecimalNumber(item.staleCount),
              invalidRate: getFloatOrDecimalNumber(item.invalidRate),
              validRate: getFloatOrDecimalNumber(item.validRate),
              staleRate: getFloatOrDecimalNumber(item.staleRate),
            }
          }
        ));
      }
    }),
    getSharesShared: build.query({
      query: (params = {}) => {
        const {
          dateRange = DAY,
          miner: minerAddress,
          coin,
          worker = '',
          offset = 0
        } = params;
        const { window, limit } = _get(SHARED_TIME_RANGES, dateRange);
        const queryParams = qs.stringify({
          minerAddress,
          coin,
          worker,
          window,
          limit,
          offset,
        }, { skipNull: true })

        return {
          url: `/v1/stats/shares?${queryParams}`,
          method: 'GET',
        }
      },
      transformResponse: (response: any) => {
        const items = _get(response, 'items', []);
        return _sortBy(items, 'timestamp').map(item => (
          {
            ...item,
            ...{
              invalidCount: getFloatOrDecimalNumber(item.invalidCount),
              validCount: getFloatOrDecimalNumber(item.validCount),
              staleCount: getFloatOrDecimalNumber(item.staleCount),
              invalidRate: getFloatOrDecimalNumber(item.invalidRate),
              validRate: getFloatOrDecimalNumber(item.validRate),
              staleRate: getFloatOrDecimalNumber(item.staleRate),
            }
          }
        ));
      }
    }),
  }),
});

export const {
  useGetSharesQuery,
  useGetSharesSharedQuery,
} = extendedApi;

export const {
  getShares,
  getSharesShared,
} = extendedApi.endpoints;
